"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GuestInfo = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var GuestInfo = function GuestInfo() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.143 0a4.572 4.572 0 1 0 4.573 4.571A4.572 4.572 0 0 0 9.143 0Zm1.143 18.286a7.995 7.995 0 0 1 3.784-6.8 3.44 3.44 0 0 0-.628-.057H4.844a3.43 3.43 0 0 0-3.075 1.897L.122 16.629a1.142 1.142 0 0 0 1.018 1.657h9.146Zm2.285 0a5.714 5.714 0 1 1 11.43 0 5.714 5.714 0 0 1-11.43 0Zm6-2.286a.286.286 0 0 0 .286-.286v-.571a.286.286 0 0 0-.286-.286H18a.286.286 0 0 0-.286.286v.571c0 .158.128.286.286.286h.571Zm-.857 1.343c0-.11.09-.2.2-.2h.743c.11 0 .2.09.2.2v4.171a.2.2 0 0 1-.2.2h-.743a.2.2 0 0 1-.2-.2v-4.171Z",
    fill: "currentColor"
  }));
};

exports.GuestInfo = GuestInfo;